import { useState, useEffect } from "react";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FilesCreate from "../file/FilesCreate";
import RelatedListFiles from "../file/RelatedListFiles";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import Path from "../common/Path";
import PubSub from "pubsub-js";
import Chat from "../common/Chat";
import jwt_decode from "jwt-decode";
import { ROUTES } from "../../constants/webRouting";
import { formatDate, formatDateForCreatedDate, formatDateForView, getUserDetails } from "../../utils/helper";
import RelatedListTask from "../task/RelatedListTask";
import RelatedListHandover from "../handover/RelatedListHandover";
import TaskEdit from "../task/TaskEdit";
import { PaymentEdit, PaymentRelatedList } from "../orderAmc";
import PERMISSIONS from "../../constants/permissions";

const OrderAmcView = () => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();

  const [statusArray, setStatusArray] = useState(
    constants.AMC_STATUS_VALUES
  );


  // console.log('state',location.state);
  const [orderAmc, setOrderAmc] = useState(
    location.state ? location.state : {}
  );
  // console.log('orderAmc', orderAmc);

  const [modalShow, setModalShow] = useState(false);
  const [modalShowFile, setModalShowFile] = useState(false);
  const [modalShowTask, setModalShowTask] = useState(false);

  const [refreshFileList, setRefreshFileList] = useState(false);
  const [refreshTaskList, setRefreshTaskList] = useState();

  const [relatedListFiles, setRelatedListFiles] = useState(true);
  const [relatedListTaskList, setRelatedListTask] = useState(false);

  const [showDetails, setShowDetails] = useState(true);
  const [showNotesMessages, setShowNotesMessages] = useState(false);

  const [editDisable, setDisableEdit] = useState(true);

  // const [userInfo, setUserInfo] = useState({});
  const [modalShowPayment, setModalShowPayment] = useState(false);
  const [relatedListPayment, setRelatedListPayment] = useState(false);
  const [payments, setPayments] = useState({}); // For Payments Tracking Use.
  const [refreshPaymentList, setRefreshPaymentList] = useState();
  const [receivedPayment, setReceivedPayment] = useState(0);

  // const isInstallationSupervisor =
  //   userInfo?.userrole?.name === "Installation Supervisor";
  const isInstallationSupervisor = userInfo?.userrole === "Installation Supervisor";
  useEffect(() => {
    // let userInfoJWT = jwt_decode(localStorage.getItem("token"));
    // setUserInfo(userInfoJWT);
    fetchOffer();
    // userInfoJWT.id === orderAmc.owner_id && setDisableEdit(false);
  }, []);

  const fetchOffer = () => {
    if (
      !orderAmc.id &&
      location.hasOwnProperty("pathname") &&
      location.pathname.split("/").length >= 3
    ) {
      orderAmc.id = location.pathname.split("/")[2];
    }
    async function init() {
      let result = await fuziElevatorsApi.fetchOrderAmcById(orderAmc.id);
      const fetchPayment = await fuziElevatorsApi.fetchOrdeAMCWisePayments(
        orderAmc.id
      ); //Using to Fetch Payments Record Wise By id

      if (fetchPayment) {
        setPayments(fetchPayment);
      } else {
        setPayments({});
      }
      if (result) {
        setOrderAmc(result);
      } else {
        setOrderAmc({});
      }
    }
    init();
  };

  const deleteOrderAmc = async () => {
    const result = await fuziElevatorsApi.deleteOrderAmcById(orderAmc.id);

    if (result?.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Deleted",
        message: "Record Deleted successfully",
      });
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Record update Error",
        message: result?.errors,
      });
    }
    navigate(ROUTES.ORDER_AMC.LIST);
  };

  const edit = () => {
    navigate(`${ROUTES.ORDER_AMC.LIST}/${orderAmc.id}/e`, { state: orderAmc });
  };

  const handleRelatedListTab = (key) => {
    if (key === "files") {
      setRelatedListFiles(true);
      setRelatedListTask(false);
      setRelatedListPayment(false);
    } else if (key === "tasks") {
      setRelatedListFiles(false);
      setRelatedListTask(true);
      setRelatedListPayment(false);
    } else if (key === "payment") {
      setRelatedListPayment(true);
      setRelatedListFiles(false);
      setRelatedListTask(false);
    }
  };

  const handleTab = (key) => {
    if (key === "details") {
      setShowDetails(true);
      setShowNotesMessages(false);
    } else if (key === "notesMessages") {
      setShowDetails(false);
      setShowNotesMessages(true);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    fetchOffer();
  };

  const submitTasks = () => {
    setModalShowTask(false);
    setRefreshTaskList((prev) => !prev);
  };

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [address, setAddress] = useState(`${orderAmc.site_address}`); // Default address

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtztwOW6bufAlbBWfO1k5FdZTkpUP_gmI&callback=initMap`;
        googleMapScript.async = true;
        googleMapScript.defer = true;
        googleMapScript && window.document.body.appendChild(googleMapScript);
      } else {
        window.initMap();
      }
    };

    window.initMap = () => {
      myMapFunction();
    };

    loadGoogleMapsScript();
  }, [latitude, longitude, address]);

  const myMapFunction = async () => {
    if (!latitude || !longitude) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          setLatitude(location.lat());
          setLongitude(location.lng());

          const mapProp = {
            center: location,
            zoom: 14,
          };

          const map = new window.google.maps.Map(
            document.getElementById("googleMapaddress"),
            mapProp
          );

          const marker = new window.google.maps.Marker({
            map,
            position: location,
            title: results[0].formatted_address,
          });

          const infowindow = new window.google.maps.InfoWindow({
            content: results[0].formatted_address,
          });

          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });

          setAddress(results[0].formatted_address);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
    } else {
      const location = new window.google.maps.LatLng(latitude, longitude);
      const mapProp = {
        center: location,
        zoom: 14,
      };

      const map = new window.google.maps.Map(
        document.getElementById("googleMapaddress"),
        mapProp
      );

      const marker = new window.google.maps.Marker({
        map,
        position: location,
        title: address,
      });

      const infowindow = new window.google.maps.InfoWindow({
        content: address,
      });

      marker.addListener("click", () => {
        infowindow.open(map, marker);
      });
    }
  };

  //Payment Block Added By Farhan Khan
  const submitpayments = () => {
    setModalShowPayment(false);
    setRefreshPaymentList(Date.now());
    // setModalShowTask(false);
    fetchOffer(); //Added by Farhan to Refresh Data.
  };

  const onPaymentListUpdate = (total) => {
    setReceivedPayment(total);
  };

  const formatAmount = (value) => {
    if (isNaN(value)) {
      return "0";
    }
    const num = parseFloat(value);
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  //End Here

  return (
    <Container className="pb-5">
      {orderAmc && (
        <>
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteOrderAmc={deleteOrderAmc}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="orderAmc"
            />
          )}

          <Row className="view-form   mx-auto">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  onClick={() => navigate(ROUTES.ORDER_AMC.LIST)}
                >
                  AMC's
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>

            <Col lg={12} className="">
              <Container className="pb-3 sticky-card-header-view">
                <Row className="view-form-header-lead bg-custom align-items-center rounded  ">
                  <Col lg={8}>
                    <h6 className="m-0 ">AMC</h6>
                    <h4 className="m-0 ">{orderAmc.offer_name_label || ""}</h4>
                  </Col>
                  <Col lg={4} className="d-flex justify-content-end gap-3">

                    {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_AMC].some(permission => {
                      return userInfo?.permissions?.map(p => p.name).includes(permission);
                    }) && (
                        <Button
                          size="sm"
                          className="btn-edit"
                          onClick={() => edit(true)}
                        >
                          <i className="fa-regular fa-pen-to-square"></i>
                        </Button>
                      )}

                    {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_AMC].some(permission => {
                      return userInfo?.permissions?.map(p => p.name).includes(permission);
                    }) && (
                        <Button
                          size="sm"
                          className="btn-delete"
                          onClick={() => setModalShow(true)}
                        >
                          <i className="fa fa-trash-o"></i>
                        </Button>
                      )}
                  </Col>
                </Row>
              </Container>
              <Card>
                <CardHeader className="sticky-tabs-header">
                  <Col lg={12} className="mt-4" style={{ color: "#fff" }}>
                    <Tabs
                      defaultActiveKey="details"
                      id="uncontrolled-tab-example"
                      onSelect={(key) => handleTab(key)}
                      style={{ marginBottom: "12px" }}
                    >
                      <Tab eventKey="details" title="Details"></Tab>
                      <Tab
                        eventKey="notesMessages"
                        title="Notes & Messages"
                      ></Tab>
                    </Tabs>
                  </Col>
                </CardHeader>

                <CardBody className="card-body-scroll">
                  <Container>
                    {showDetails && (
                      <Row className="">
                        <Col lg={12}>
                          <div className="scrollable-container">
                            <Path
                              values={statusArray?.map((status) => ({
                                ...status,
                                highlight: status.sortorder <= orderAmc.amc_status,
                              })) || []}
                              selectedValue={orderAmc.amc_status}
                            />
                          </div>
                        </Col>
                        <>
                          <Col lg={6}>
                            <label>Job Number</label>
                            <span>{orderAmc.job_no || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Order</label>
                            <span>{orderAmc.offer_name_label || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Lead</label>
                            <span>{orderAmc.lead_name || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Status</label>
                            <span>{orderAmc.amc_status || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Email</label>
                            <span>{orderAmc.email || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Phone</label>
                            <span>{orderAmc.phone || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>WhatsApp Number</label>
                            <span>{orderAmc.whatsapp_no || ""}</span>
                          </Col>
                          {/* <Col lg={6}>
                            <label>Assigned User</label>
                            <span> 
                              <img
                                src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                                className="rounded-circle"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  objectFit: "cover",
                                }}
                                alt=""
                              />
                              <img
                                src={localStorage.getItem("myimage")}
                                className="rounded-circle"
                                style={{ height: "30px" }}
                                alt=""
                              />

                              <Badge
                                bg="warning"
                                className="mx-2"
                                style={{ display: "inline", color: "#000" }}
                              >
                                {orderAmc?.owner_name || ""}
                              </Badge>
                            </span>
                          </Col> */}
                          <Col lg={6}>
                            <label>Assigned Users</label>
                            <span>
                              <div className="d-flex flex-wrap gap-1">
                                {orderAmc?.owner_ids?.map((item) =>
                                  <Badge
                                    bg="warning"
                                  >
                                    <Link to={`${ROUTES.USER.LIST}/${item.value}`} className="text-decoration-none text-dark fw-bold">
                                      {item.label}
                                    </Link>
                                  </Badge>
                                )}
                              </div>
                            </span>
                          </Col>
                          {/* formatDateForView added by shahir hussain 27-08-2025 */}
                          <Col lg={12}>
                            <label>Created Date</label>
                            <span>
                              {formatDateForView(
                                orderAmc?.createddate || ""
                              )}
                            </span>
                          </Col>
                        </>

                        <>
                          <Col lg={12} className="section-header">CUSTOMER INFORMATION</Col>
                          <Col lg={6}>
                            <label>Customer Type</label>
                            <span>{orderAmc.customer_type || ""}</span>
                          </Col>

                          {orderAmc?.customer_type === "Corporate" && (
                            <Col lg={6}>
                              <label>Company Name</label>
                              <span>{orderAmc.company_name || ""}</span>
                            </Col>
                          )}

                          <Col lg={6}>
                            <label>Sector</label>
                            <span>{orderAmc.sector || ""}</span>
                          </Col>

                          {orderAmc.is_gst === "Yes" && (
                            <Col lg={6}>
                              <label>GST Number</label>
                              <span>{orderAmc.gst_no}</span>
                            </Col>
                          )}
                          {/* Add Segment Type by shahir hussain 02-02-2026 */}
                          <Col lg={6}>
                            <label>Segment Type</label>
                            <span>{orderAmc?.segment || ""}</span>
                          </Col>
                        </>

                        <>
                          <Col lg={12} className="section-header">AMC INFORMATION</Col>
                          <Col lg={6}>
                            <label>AMC Upto</label>
                            <span>{orderAmc.amc_upto || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Billing Name</label>
                            <span>{orderAmc.billing_name || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Billing Number</label>
                            <span>{orderAmc.billing_no || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Billing Date</label>
                            <span>{orderAmc?.billing_date ? formatDateForView(orderAmc.billing_date) : ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Billing Amount</label>
                            <span>{orderAmc.billing_amount || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Parts Type</label>
                            <span>{orderAmc.parts_type || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Period</label>
                            <span>{orderAmc.period || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Start Date</label>
                            <span>
                              {orderAmc?.start_date
                                ? formatDateForView(orderAmc.start_date)
                                : ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Upto</label>
                            <span>
                              {orderAmc?.end_date
                                ? formatDateForView(orderAmc.end_date)
                                : ""}
                            </span>
                          </Col>
                          {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some(permission => {
                            return userInfo?.permissions?.map(p => p.name).includes(permission);
                          }) && (
                              <>
                                <Col lg={6}>
                                  <label>Amc Price</label>
                                  <span>{orderAmc.amc_total_amount || ""}</span>
                                </Col>

                                {/* <Col lg={6}>
                            <label>Basic Amount Value</label>
                            <span>{orderAmc.basic_amount || ""}</span>
                          </Col> */}

                                <Col lg={6}>
                                  <label>Cheque Amount</label>
                                  <span>{orderAmc.cheque_amount || ""}</span>
                                </Col>

                                <Col lg={6}>
                                  <label>Cash Amount</label>
                                  <span>{orderAmc.cash_amount || ""}</span>
                                </Col>
                                <Col lg={6}>
                                  <label>TPC Amount</label>
                                  <span>{orderAmc.tpc_amount || ""}</span>
                                </Col>
                              </>
                            )}

                          <Col lg={6}>
                            <label>Payment Status</label>
                            <span>{orderAmc.payment_status || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Payment Mode</label>
                            <span>{orderAmc.payment_mode || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Payment Frequency</label>
                            <span>{orderAmc.payment_frequency || ""}</span>
                          </Col>
                        </>

                        <>
                          <Col lg={12} className="section-header">
                            ADDRESS INFORMATION
                          </Col>

                          <Col lg={6}>
                            <label>Site Address</label>
                            <span>{orderAmc.site_address || ""}</span>
                          </Col>
                          {/* Added by shahir hussain */}
                          <Col lg={6}>
                            <label>Area</label>
                            <span>{orderAmc.area || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>State</label>
                            <span>{orderAmc.state || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>City</label>
                            <span>{orderAmc.city || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Office Address</label>
                            <span>{orderAmc.office_address || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Office City</label>
                            <span>{orderAmc.office_city || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Pincode</label>
                            <span>{orderAmc.pincode || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Country</label>
                            <span>{orderAmc.country || ""}</span>
                          </Col>
                        </>

                        {
                          orderAmc.is_lost &&
                          <>
                            <Col lg={12} className="section-header">
                              LOST AMC INFORMATION
                            </Col>
                            <Col lg={6}>
                              <label>Lost Date</label>
                              <span>{formatDateForCreatedDate(orderAmc?.lost_date || "")}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Lost Remark</label>
                              <span>{orderAmc.lost_remark}</span>
                            </Col>
                          </>
                        }
                        {/* Imran Khan Added condition for Payment Related List to hide from Installation Supervisor 24-Feb-2026 */}
                        {!isInstallationSupervisor &&
                          [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some((permission) => {
                            return userInfo?.permissions?.map((p) => p.name).includes(permission);
                          }) && (
                            <>
                              <Col lg={12} className="section-header">
                                AMOUNT INFORMATION
                              </Col>
                              {/*<Col lg={6}>
                                <label>Basic Amount Value</label>
                                <Badge
                                  bg="warning"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(
                                      orderAmc?.basic_amount || 0
                                    )}{" "}
                                </Badge>
                              </Col> */}
                              <Col lg={6}>
                                <label>AMC Value Without Tax</label>
                                <Badge
                                  bg="info"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(
                                      Number(orderAmc?.amc_total_amount) || 0
                                    )}{" "}
                                </Badge>
                              </Col>

                              <Col lg={6}>
                                <label>Total Received Amount</label>
                                <Badge
                                  bg="success"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(Number(payments?.total || 0))}
                                </Badge>
                              </Col>

                              <Col lg={6}>
                                <label>Cash Amount</label>
                                <Badge
                                  bg="info"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(Number(orderAmc?.cash_amount) || 0)}
                                </Badge>
                              </Col>

                              <Col lg={6}>
                                <label>Received Cash Amount</label>
                                <Badge
                                  bg="success"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(Number(payments?.Cash) || 0)}
                                </Badge>
                              </Col>

                              <Col lg={6}>
                                <label>Cheque Amount</label>
                                <Badge
                                  bg="info"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(
                                      Number(orderAmc?.cheque_amount) || 0
                                    )}
                                </Badge>
                              </Col>

                              <Col lg={6}>
                                <label>Received Cheque Amount</label>
                                <Badge
                                  bg="success"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(Number(payments?.Cheque) || 0)}
                                </Badge>
                              </Col>

                              {/* Tax Amount - Fixed Imran Khan 11-Feb-2026 */}
                              <Col lg={6}>
                                <label>Tax Amount</label>
                                <Badge
                                  bg="warning"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(Number(orderAmc?.tax_amount) ?? 0)}
                                </Badge>
                              </Col>

                              {/* Pending Cheque Amount - Fixed with Math.max Imran Khan 11-Feb-2026*/}
                              <Col lg={6}>
                                <label>Pending Cheque Amount</label>
                                <Badge
                                  bg="danger"
                                  style={{
                                    width: "30%",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(
                                      Math.max(
                                        (Number(orderAmc?.cheque_amount) || 0) +
                                        (Number(orderAmc?.tax_amount) || 0) -
                                        (Number(payments?.Cheque) || 0),
                                        0
                                      )
                                    )}
                                </Badge>
                              </Col>

                              <Col lg={6}>
                                <label>Total Cheque Amount</label>
                                <Badge
                                  bg="dark"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(
                                      (Number(orderAmc?.cheque_amount) || 0) +
                                      (Number(orderAmc?.tax_amount) || 0)
                                    )}
                                </Badge>
                              </Col>

                              <Col lg={6}>
                                <label>Pending Cash Amount</label>
                                <Badge
                                  bg="danger"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(
                                      Number(orderAmc?.cash_amount) -
                                      (Number(payments?.Cash) || 0)
                                    )}
                                </Badge>
                              </Col>

                              <Col lg={6}>
                                <label>Due Amount</label>
                                <Badge
                                  bg="dark"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(Number(orderAmc?.due_amount || 0))}
                                </Badge>
                              </Col>

                              {/* Total Pending Amount - Fixed Imran Khan 11-Feb-2026 */}
                              <Col lg={6}>
                                <label>Total Pending Amount</label>
                                <Badge
                                  bg="danger"
                                  style={{
                                    width: "30%",
                                    fontWeight: "normal",
                                    fontSize: "1rem",
                                    textAlign: "left",
                                  }}
                                >
                                  {"₹ " +
                                    formatAmount(
                                      Number(orderAmc?.due_amount) -
                                      Number(payments?.total || 0)
                                    )}
                                </Badge>
                              </Col>
                            </>
                          )} 
                        <Col lg={12}>
                          <div
                            id="googleMapaddress"
                            className="my-2"
                            style={{
                              width: "100%",
                              height: "300px",
                              border: "1px solid black",
                            }}
                          ></div>
                        </Col>
                      </Row>
                    )}

                    {showNotesMessages && (
                      <Card className="mt-2">
                        <Row className="mt-4">
                          <Col lg={12}>
                            <Chat parentid={orderAmc.id} />
                          </Col>
                        </Row>
                      </Card>
                    )}
                  </Container>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Card bg="light" text="light" className="mb-2 mt-4 shadow">
            <Card.Header className="d-flex justify-content-between">
              <Tabs
                defaultActiveKey="files"
                id="uncontrolled-tab-example"
                onSelect={(key) => handleRelatedListTab(key)}
              >
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(permission => {
                  return userInfo?.permissions?.map(p => p.name).includes(permission);
                }) && (<Tab eventKey="files" title="Files"></Tab>)}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(permission => {
                  return userInfo?.permissions?.map(p => p.name).includes(permission);
                }) && (<Tab eventKey="tasks" title="Tasks"></Tab>)}
                {!isInstallationSupervisor &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some((permission) => {
                  return userInfo?.permissions?.map((p) => p.name).includes(permission);
                }) && <Tab eventKey="payment" title="Payment"></Tab>}

              </Tabs>

              {(relatedListFiles && [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_FILE].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
              })) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowFile(true)}
                  >
                    New File
                  </Button>
                )}

              {(relatedListTaskList && [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_TASK].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
              })) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowTask(true)}
                  >
                    New Task
                  </Button>
                )}
              {/* Imran Khan Added condition for Payment Related List to hide from Installation Supervisor 24-Feb-2026 */}
              {!isInstallationSupervisor &&
                relatedListPayment &&
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_PAYMENT].some(
                  (permission) => {
                    return userInfo?.permissions?.map((p) => p.name).includes(permission);
                  }
                ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowPayment(true)}
                  >
                    New Payment
                  </Button>
                )}

              {/* Modals */}
              {modalShowFile && (
                <FilesCreate
                  show={modalShowFile}
                  onHide={() => setModalShowFile(false)}
                  parent={orderAmc}
                  table="medicaltest"
                  submitFiles={submitFiles}
                />
              )}

              {modalShowTask && (
                <TaskEdit
                  show={modalShowTask}
                  onHide={() => setModalShowTask(false)}
                  parentid={orderAmc?.id}
                  table="orderAmc"
                  submitTasks={submitTasks}
                />
              )}

              {modalShowPayment && (
                <PaymentEdit
                  show={modalShowPayment}
                  onHide={() => setModalShowPayment(false)}
                  parent={orderAmc}
                  table="paymentTablel"
                  submitpayments={submitpayments}
                  pendingAmount={
                    orderAmc.amc_total_amount - (payments.paidamount || 0)
                  }
                // pendingAmount=  {(lead.amc_total_amount - (payments.paidamount || 0)) }
                />
              )}
            </Card.Header>
            <Card.Body>
              {(relatedListFiles && [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
              })) && (
                  <RelatedListFiles
                    refreshFileList={refreshFileList}
                    // onFileUpdate={updateCounter}
                    parent={orderAmc}
                    submitFiles={submitFiles}
                  />
                )}

              {(relatedListTaskList && [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
              })) && (
                  <RelatedListTask
                    refreshTaskList={refreshTaskList}
                    parent={orderAmc}
                    submitFiles={submitTasks}
                    table="Order"
                  />
                )}
              {/* Imran Khan Added condition for Payment Related List to hide from Installation Supervisor 24-Feb-2026 */}
              {!isInstallationSupervisor &&
                relatedListPayment &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some((permission) => {
                  return userInfo?.permissions
                    ?.map((p) => p.name)
                    .includes(permission);
                }) && (
                  <PaymentRelatedList
                    refreshPaymentList={refreshPaymentList}
                    parent={orderAmc}
                    onPaymentListUpdate={onPaymentListUpdate}
                    parentsubmitpayments={submitpayments}
                    pendingAmount={
                      orderAmc.amc_total_amount - (payments.paidamount || 0)
                    }
                  />
                )}
            </Card.Body>
          </Card>
        </>
      )}
    </Container>
  );
};
export default OrderAmcView;
